/** Badge colour choices. The check mark next to names always uses EAB blue. */
export const BADGE_CHECK_COLOR = "#1B62E0";

export const BADGE_COLORS: { key: string; label: string; hex: string }[] = [
  { key: "blue", label: "Blue", hex: "#1B62E0" },
  { key: "green", label: "Green", hex: "#16A34A" },
  { key: "gold", label: "Gold", hex: "#CA8A04" },
  { key: "purple", label: "Purple", hex: "#7C3AED" },
  { key: "red", label: "Red", hex: "#DC2626" },
  { key: "teal", label: "Teal", hex: "#0D9488" },
];

export function badgeHex(key: string | null | undefined): string {
  return BADGE_COLORS.find((c) => c.key === key)?.hex ?? BADGE_CHECK_COLOR;
}
